<template>
  <div
    class="full-width"
    :style="option.style || ''"
    :class="option.className"
  >
    <div
      style="line-height: 1rem;"
      :class="option.valueClassName || ''"
      :style="option.valueStyle"
    >
      {{ option.value }}
    </div>

    <div
      v-if="option.additionalValue"
      :class="option.additionalValueClassName || ''"
      class="text-caption"
      style="line-height: 1rem;"
      @click="doCopy(option.additionalValue)"
    >
      {{ option.additionalValue }}
    </div>
  </div>
</template>

<script>
// Utils
import { doCopy } from './../../utils/copy-utils'

export default {
  name: 'ActionText',
  props: {
    option: {
      type: Object,
      required: true
    }
  },
  methods: {
    doCopy (content) {
      return doCopy(content)
    }
  }
}
</script>
